import React, { useContext } from "react";
import { Lock, Loader2, ShieldAlert } from "lucide-react";

import useModules from "../../hooks/useModules";
import MainContainer from "../MainContainer";
import { AuthContext } from "../../context/Auth/AuthContext";
import { hasPermission } from "../Can";

// Qual módulo cada rota exige.
const MODULO_POR_ROTA = {
	"/campaigns": "campaigns",
	"/contact-lists": "campaigns",
	"/crm": "crm",
	"/flows": "flows",
	"/boards": "kanban",
	"/personal-kanban": "kanban",
	"/internal-chat": "internalChat",
	"/scheduled-messages": "schedules",
	"/webhooks": "webhooks",
	"/reports": "reports",
	"/media-library": "mediaLibrary",
};

// Qual permissão de cargo cada rota exige.
const PERMISSAO_POR_ROTA = {
	"/flows": "automation:view",
	"/ai": "ai:use",
	"/operational-panel": "supervision:monitor",
	"/reports": "dashboard:reports",
	"/roles": "users:roles",
	"/users": "users:create",
	"/connections": "connections:manage",
	"/crm": "crm:manage",
	"/campaigns": "campaigns:create",
};

export const moduloDaRota = (caminho) => {
	const chave = Object.keys(MODULO_POR_ROTA).find(
		(prefixo) => caminho === prefixo || caminho.startsWith(`${prefixo}/`)
	);

	return chave ? MODULO_POR_ROTA[chave] : null;
};

const ModuleGuard = ({ caminho, children }) => {
	const { temModulo, carregando } = useModules();
	const { user } = useContext(AuthContext);

	const modulo = moduloDaRota(caminho);

	if (modulo) {
		if (carregando) {
			return (
				<MainContainer>
					<div className="flex flex-1 items-center justify-center">
						<Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
					</div>
				</MainContainer>
			);
		}

		if (!temModulo(modulo)) {
			return (
				<MainContainer>
					<div className="flex flex-1 items-center justify-center p-6">
						<div className="max-w-sm text-center">
							<span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-muted">
								<Lock className="h-5 w-5 text-muted-foreground" />
							</span>
							<h2 className="mt-4 text-base font-semibold">
								Este recurso não está no seu plano
							</h2>
							<p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">
								Fale com quem administra a sua conta para liberar.
							</p>
						</div>
					</div>
				</MainContainer>
			);
		}
	}

	const prefixoPermissao = Object.keys(PERMISSAO_POR_ROTA).find(
		(prefixo) => caminho === prefixo || caminho.startsWith(`${prefixo}/`)
	);

	if (prefixoPermissao && user) {
		const chave = PERMISSAO_POR_ROTA[prefixoPermissao];
		if (!hasPermission(user, chave)) {
			return (
				<MainContainer>
					<div className="flex flex-1 items-center justify-center p-6">
						<div className="max-w-sm text-center">
							<span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10 text-destructive">
								<ShieldAlert className="h-6 w-6" />
							</span>
							<h2 className="mt-4 text-base font-semibold">
								Acesso não permitido
							</h2>
							<p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">
								Seu cargo não possui permissão para acessar esta página ({chave}). Fale com quem administra a conta para liberar o acesso.
							</p>
						</div>
					</div>
				</MainContainer>
			);
		}
	}

	return children;
};

export default ModuleGuard;
